import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { ResponseCatalog, RequestParams } from 'Models'
import {
	CreateRbidosRequest,
	CreateOptionsLead,
	RbidosRequest,
	TYPE_CABINET,
	OkvedModel,
	SuggestFmsUnitModel,
} from 'Pages/registratorCabinet'
import { Callback } from 'Src/types/utilTypes'

export type OrdersListState = {
	reload: boolean
	rbidosRequest: ResponseCatalog<RbidosRequest>
	socketRbidosRequest: RbidosRequest
	soketIds: number[]
	requestParams: RequestParams
	okveds: OkvedModel[]
	rbidosCustomer: any
	showMessage: boolean
	suggestFmsUnit: SuggestFmsUnitModel[]
	createOptions: Partial<
		Pick<
			CreateRbidosRequest,
			'org_type' | 'online_identification' | 'need_sms' | 'with_reserve_account'
		>
	>
	createOptionsLead: CreateOptionsLead
	createOptionsCabinet: TYPE_CABINET | null
}

export const ordersListInitialState: OrdersListState = {
	reload: false,
	rbidosRequest: new ResponseCatalog<RbidosRequest>(),
	socketRbidosRequest: null,
	soketIds: [],
	requestParams: new RequestParams(),
	okveds: [],
	rbidosCustomer: null,
	showMessage: true,
	suggestFmsUnit: [],
	createOptions: {
		org_type: null,
		online_identification: null,
		need_sms: false,
	},
	createOptionsLead: {
		scenario: null,
		with_reserve_account: null,
		online_identification: null,
	},
	createOptionsCabinet: null,
}

export namespace OrdersListNS {
	export type GetRbidosRequestList = PayloadAction<{
		params: RequestParams
		clear?: boolean
		callback?: Callback
	}>
	export type SetRbidosRequestList = PayloadAction<ResponseCatalog<RbidosRequest>>
	export type SetRequestParams = PayloadAction<RequestParams>
	export type InfotecsLogin = PayloadAction<{
		data: Record<string, string>
	}>
	export type SetCreateOptions = PayloadAction<
		Partial<
			Pick<
				CreateRbidosRequest,
				'org_type' | 'online_identification' | 'need_sms' | 'with_reserve_account'
			>
		>
	>
	export type SetCreateOptionsLead = PayloadAction<Partial<CreateOptionsLead>>
	export type SetCreateOptionsCabinet = PayloadAction<TYPE_CABINET>
	export type SetSingleRbidosRequest = PayloadAction<{ id: number; request: RbidosRequest }>
}

export const ordersListSlice = createSlice({
	name: 'ordersList',
	initialState: ordersListInitialState,
	reducers: {
		getAll: (state, action: OrdersListNS.GetRbidosRequestList) => {},
		setAll: (state, action: OrdersListNS.SetRbidosRequestList) => {
			state.reload = state.reload ?? false
			state.rbidosRequest = action.payload
		},
		setRequestParams: (state, action: OrdersListNS.SetRequestParams) => {
			state.requestParams = action.payload
		},
		clearAll: (state) => {
			state.rbidosRequest = new ResponseCatalog<RbidosRequest>()
			state.requestParams = new RequestParams()
		},
		infotecsLogin: (state, action: OrdersListNS.InfotecsLogin) => {},
		deleteInfotecsLogin: (state) => {},
		setCreateOptions: (state, action: OrdersListNS.SetCreateOptions) => {
			state.createOptions = {
				...state.createOptions,
				...action.payload,
			}
		},
		clearCreateOptions: (state) => {
			state.createOptions = ordersListInitialState.createOptions
		},
		setCreateOptionsLead: (state, action: OrdersListNS.SetCreateOptionsLead) => {
			state.createOptionsLead = {
				...state.createOptionsLead,
				...action.payload,
			}
		},
		setCreateOptionsCabinet: (state, action: OrdersListNS.SetCreateOptionsCabinet) => {
			state.createOptionsCabinet = action.payload
		},
		clearCreateOptionsLead: (state) => {
			state.createOptionsLead = ordersListInitialState.createOptionsLead
		},
		clearCreateOptionsCabinet: (state) => {
			state.createOptionsCabinet = ordersListInitialState.createOptionsCabinet
		},
		clearAllOptions: (state) => {
			state.createOptions = ordersListInitialState.createOptions
			state.createOptionsLead = ordersListInitialState.createOptionsLead
			state.createOptionsCabinet = ordersListInitialState.createOptionsCabinet
		},
		setSingleRbidosRequest: (state, action: OrdersListNS.SetSingleRbidosRequest) => {
			const { id, request } = action.payload
			state.rbidosRequest.entries = state.rbidosRequest.entries?.map((item) =>
				item.id !== id ? item : { ...request }
			)
		},
	},
})
